import React, { useState, useEffect } from 'react';
import { getAllPortfolios } from '../../common/portfolioStore';
import { PortfolioListItem, PortfolioSidebar } from './PortfolioParts';

function PortfolioList() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const items = await getAllPortfolios();
        setItems(items);
      } catch (err) {
        console.error(err);
      }
    };
    load();
  }, []);

  return (
    <section className="blog-main section-padding">
      <div className="container">
        <div className="row lg-marg justify-content-around">
          <div className="col-lg-8">
            <div className="md-mb80">
              {items.map((item, i) => (
                <PortfolioListItem
                  key={item.id}
                  item={item}
                  isLast={i === items.length - 1}
                />
              ))}
              {items.length === 0 && (
                <p className="p-color">Henüz proje eklenmemiş.</p>
              )}
            </div>
          </div>
          <div className="col-lg-4">
            <PortfolioSidebar items={items} />
          </div>
        </div>
      </div>
    </section>
  );
}

export default PortfolioList;
